import React from "react";
import {
  FaBookOpen,
  FaCheckCircle,
  FaEnvelope,
  FaFileContract,
  FaInfoCircle,
  FaLock,
  FaMoneyCheckAlt,
  FaShieldAlt,
  FaSyncAlt,
  FaTags,
  FaTimesCircle,
} from "react-icons/fa";
import "./TermsOfService.css";

const SUPPORT_EMAIL = "kugathaj@gmail.com";

const TermsOfUse: React.FC = () => {
  return (
    <main className="tos-page">
      <section className="tos-container">
        <header className="tos-header-card">
          <p className="tos-kicker">
            <FaShieldAlt />
            <span>Nutzungsbedingungen</span>
          </p>

          <h1 className="tos-page-title">
            Nutzungsbedingungen für DEUTSCH A1-C2
          </h1>

          <p className="tos-subtitle">
            Diese Nutzungsbedingungen regeln Ihren Zugriff auf die DEUTSCH A1-C2
            App und die Nutzung unserer Lerninhalte.
          </p>
        </header>

        <div className="tos-learning-grid">
          <article className="tos-group">
            <div className="tos-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="tos-card-left">
              <div className="tos-level-block">
                <span className="tos-level-icon">
                  <FaFileContract />
                </span>

                <span className="tos-status">Bedingungen</span>
              </div>

              <div className="tos-title-block">
                <h2>Nutzung</h2>
                <p>Zugang</p>
                <small>Dienst</small>
              </div>
            </section>

            <section className="tos-card-right">
              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaInfoCircle />
                  </span>
                  <h2>Einführung</h2>
                </div>

                <p>
                  Diese Nutzungsbedingungen regeln Ihren Zugriff auf und Ihre
                  Nutzung der German A1-C2 App („App“, „wir“, „uns“ oder
                  „unser“). Wenn Sie die App herunterladen, öffnen oder
                  verwenden, stimmen Sie diesen Bedingungen zu. Wenn Sie nicht
                  zustimmen, nutzen Sie die App bitte nicht.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaBookOpen />
                  </span>
                  <h2>1. Der Dienst</h2>
                </div>

                <p>
                  German A1-C2 bietet Lerninhalte zum Deutschlernen an. Die App
                  kann kostenlose Inhalte, Premium-Inhalte und Werbung für
                  Nutzer ohne Premium-Zugang enthalten.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaLock />
                  </span>
                  <h2>2. Kostenloser Zugang und Premium-Zugang</h2>
                </div>

                <p>
                  Die App kann sowohl kostenlosen Zugang als auch Premium-Zugang
                  anbieten.
                </p>

                <p>
                  <strong>Kostenlose Nutzer:</strong> können eingeschränkten
                  Zugriff auf bestimmte Inhalte haben und Werbung sehen.
                </p>

                <p>
                  <strong>Premium-Nutzer:</strong> können zusätzliche oder
                  vollständige Inhalte, Offline-Zugang und je nach App-Version
                  und aktivem Angebot eine reduzierte oder werbefreie Nutzung
                  erhalten.
                </p>
              </div>
            </section>
          </article>

          <article className="tos-group">
            <div className="tos-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="tos-card-left">
              <div className="tos-level-block">
                <span className="tos-level-icon">
                  <FaMoneyCheckAlt />
                </span>

                <span className="tos-status">Zahlung</span>
              </div>

              <div className="tos-title-block">
                <h2>Abo</h2>
                <p>Premium</p>
                <small>Abrechnung</small>
              </div>
            </section>

            <section className="tos-card-right">
              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaSyncAlt />
                  </span>
                  <h2>3. Abonnements</h2>
                </div>

                <p>
                  Premium-Zugang kann als automatisch verlängerndes Abonnement
                  angeboten werden. Titel, Dauer und Preis des Abonnements
                  werden vor dem Kauf in der App angezeigt.
                </p>

                <p>
                  Die Zahlung wird über die Plattform abgewickelt, über die Sie
                  das Abonnement abschließen, zum Beispiel Apple App Store oder
                  Google Play. Abonnements verlängern sich automatisch, sofern
                  sie nicht mindestens 24 Stunden vor Ende des aktuellen
                  Abrechnungszeitraums gekündigt werden, sofern die jeweilige
                  Plattform nichts anderes angibt.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaMoneyCheckAlt />
                  </span>
                  <h2>4. Abrechnung und Verlängerung</h2>
                </div>

                <p>
                  Der genaue Preis kann je nach Land, Währung, Steuern,
                  Aktionsangebot, Store oder Plattform unterschiedlich sein. Der
                  Preis, der beim Kauf in der App angezeigt wird, ist der Preis,
                  der für Ihr Abonnement gilt.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaTimesCircle />
                  </span>
                  <h2>5. Kündigung und Wiederherstellung</h2>
                </div>

                <p>
                  Sie können Ihr Abonnement über die Einstellungen Ihres Apple
                  App Store- oder Google Play-Kontos verwalten oder kündigen,
                  abhängig davon, wo Sie das Abonnement abgeschlossen haben.
                  Wenn Sie kündigen, bleibt Ihr Premium-Zugang bis zum Ende des
                  aktuellen bezahlten Zeitraums aktiv. Berechtigte Käufe können
                  in der App wiederhergestellt werden, wenn diese Funktion
                  unterstützt wird.
                </p>
              </div>
            </section>
          </article>

          <article className="tos-group">
            <div className="tos-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="tos-card-left">
              <div className="tos-level-block">
                <span className="tos-level-icon">
                  <FaShieldAlt />
                </span>

                <span className="tos-status">Regeln</span>
              </div>

              <div className="tos-title-block">
                <h2>Regeln</h2>
                <p>Rechtliches</p>
                <small>Zugang</small>
              </div>
            </section>

            <section className="tos-card-right">
              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaTags />
                  </span>
                  <h2>6. Angebotscodes und Aktionszugang</h2>
                </div>

                <p>
                  Die App kann Angebotscodes, Gutscheincodes oder Zugangscodes
                  unterstützen. Solche Codes können für einen bestimmten
                  Zeitraum eingeschränkten oder vollständigen Premium-Zugang
                  gewähren und können Ablaufdaten, Voraussetzungen oder
                  zusätzliche Bedingungen haben. Aktionszugang bedeutet keinen
                  dauerhaften Premium-Zugang, sofern dies nicht ausdrücklich
                  angegeben ist.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaInfoCircle />
                  </span>
                  <h2>7. Werbung</h2>
                </div>

                <p>
                  Kostenlose Nutzer können Werbung in der App sehen. Werbung
                  kann von Drittanbietern bereitgestellt werden. Wir sind nicht
                  verantwortlich für Werbung, Webseiten, Produkte oder Dienste
                  von Drittanbietern, die über solche Anzeigen angezeigt oder
                  verlinkt werden.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaCheckCircle />
                  </span>
                  <h2>8. Erlaubte Nutzung</h2>
                </div>

                <p>
                  Sie verpflichten sich, die App nicht zu missbrauchen. Dazu
                  gehört insbesondere:
                </p>

                <p className="tos-list-text">
                  • das Umgehen von Abonnement-Beschränkungen oder
                  Zugriffskontrollen
                  <br />
                  • das Zurückentwickeln, Kopieren, Verändern oder
                  Weiterverbreiten der App, sofern dies nicht gesetzlich erlaubt
                  ist
                  <br />• die Nutzung der App auf eine Weise, die gegen
                  geltendes Recht oder Vorschriften verstößt
                </p>
              </div>
            </section>
          </article>

          <article className="tos-group">
            <div className="tos-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="tos-card-left">
              <div className="tos-level-block">
                <span className="tos-level-icon">
                  <FaFileContract />
                </span>

                <span className="tos-status">Rechte</span>
              </div>

              <div className="tos-title-block">
                <h2>Recht</h2>
                <p>Schutz</p>
                <small>Kontakt</small>
              </div>
            </section>

            <section className="tos-card-right">
              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaShieldAlt />
                  </span>
                  <h2>9. Geistiges Eigentum</h2>
                </div>

                <p>
                  Alle Inhalte, Marken, Logos, Texte, Audios, Bilder, Lektionen
                  und sonstigen Materialien in der App gehören uns oder wurden
                  uns lizenziert und sind durch geltende Gesetze zum geistigen
                  Eigentum geschützt. Sie dürfen Inhalte der App ohne Erlaubnis
                  nicht kopieren, vervielfältigen, erneut veröffentlichen oder
                  weitergeben.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaInfoCircle />
                  </span>
                  <h2>10. Haftungsausschluss</h2>
                </div>

                <p>
                  Die App wird „wie verfügbar“ und „wie gesehen“
                  bereitgestellt. Wir garantieren nicht, dass die App jederzeit
                  unterbrechungsfrei, sicher, fehlerfrei oder verfügbar ist.
                  Lernergebnisse beim Sprachenlernen können je nach Nutzer
                  unterschiedlich sein.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaShieldAlt />
                  </span>
                  <h2>11. Haftungsbeschränkung</h2>
                </div>

                <p>
                  Soweit gesetzlich zulässig, haften wir nicht für indirekte,
                  zufällige, besondere oder Folgeschäden oder Strafschäden, die
                  aus der Nutzung der App entstehen oder damit zusammenhängen.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaSyncAlt />
                  </span>
                  <h2>12. Änderungen dieser Bedingungen</h2>
                </div>

                <p>
                  Wir können diese Nutzungsbedingungen von Zeit zu Zeit
                  aktualisieren. Wenn wir Änderungen vornehmen, veröffentlichen
                  wir die neue Version auf dieser Seite. Wenn Sie die App nach
                  Inkrafttreten der aktualisierten Bedingungen weiter nutzen,
                  akzeptieren Sie diese Änderungen.
                </p>
              </div>

              <div className="tos-section">
                <div className="tos-section-title">
                  <span className="tos-section-icon">
                    <FaEnvelope />
                  </span>
                  <h2>13. Kontakt</h2>
                </div>

                <p>
                  Wenn Sie Fragen zu diesen Nutzungsbedingungen haben,
                  kontaktieren Sie uns bitte unter{" "}
                  <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
                </p>
              </div>
            </section>
          </article>
        </div>
      </section>
    </main>
  );
};

export default TermsOfUse;